// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2024 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

import { listStyles } from "@steiner/Overrides/Widgets/Brand/BrandList";
import { fontConfig } from "@steiner/XDL/PreStyle/typography";
import { color, ellipsis, xScreen } from "@steiner/XDL/Utilities";
import { css } from "styled-components";

listStyles.brandLetter = {
    variant: "h3",
    transform: "uppercase",
    css: css`
        margin-bottom: 0;
    `,
};

listStyles.backToTopLink = {
    typographyProps: {
        size: 14,
    },
};

listStyles.brandLink = {
    typographyProps: {
        ellipsis: true,
        weight: fontConfig.weight.semiBold,
        lineHeight: "22px",
        css: css`
            white-space: normal;
        `,
    },
    css: css`
        align-self: start;
    `,
};

listStyles.brandSections = {
    css: css`
        display: flex;
        flex-direction: column;
        &:not(:last-child) {
            margin-bottom: 32px;
        }
    `,
};

listStyles.brandAlphabetSections = {
    css: css`
        display: flex;
        justify-content: space-between;
        align-items: center;
        margin-bottom: 16px;
        border-bottom: 1px solid ${color("common.border")};
        padding-bottom: 12px;
    `,
};

listStyles.allBrandsTitle = {
    variant: "h2",
    css: css`
        margin-bottom: 0;
        ${xScreen("lte", "md")} {
            word-break: break-word;
            ${ellipsis(2)}
        }
    `,
};

listStyles.clearFiltersButton = {
    variant: "tertiary",
    css: css`
        margin-left: auto;
    `,
};

listStyles.titleWrapper = {
    css: css`
        display: flex;
        justify-content: space-between;
        align-items: flex-start;
        flex-wrap: wrap;
        gap: 10px;
        margin-bottom: 24px;
    `,
};

listStyles.brandItems = {
    css: css`
        display: grid;
        grid-template-columns: repeat(4, 1fr);
        gap: 25px 22px;
        ${xScreen("lte", "md")} {
            grid-template-columns: repeat(3, 1fr);
        }
        ${xScreen("lte", "sm")} {
            grid-template-columns: repeat(2, 1fr);
        }
        ${xScreen("lte", "xs")} {
            grid-template-columns: repeat(1, 1fr);
        }
    `,
};

listStyles.brandItem = {
    css: css`
        padding: 0;
        display: flex;
    `,
};

listStyles.searchKeyTitleWrapper = {
    css: css`
        display: flex;
        flex-direction: column;
        justify-content: space-between;
        align-items: flex-start;
        flex-wrap: wrap;
        gap: 10px;
    `,
};
